import React, { useEffect } from 'react';
import './App.css';
import Layout from './Layout/Layout';
import Loader from './components/Common/Loader';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Ensure the CSS is imported
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <Loader />
      <Layout />
      <ToastContainer />
    </>
  );
}

export default App;
